export const SAVE_PROPERTY_RECONFIRMATION_HOURS: number = 48;
